// extracted by mini-css-extract-plugin
export default {"container":"IconSwitch_container__+-Iv2","disabled":"IconSwitch_disabled__e9piK"};